import { joinParams } from '../utils'
import {cleanParams} from '../utils/clean-encrypt.js'

/**
 * 清洁服务接口 - 丽家会接口
 * add by lty 20190313
 * 
 */
export default {
  /**
   * 获取脏房列表
   * @param {+} hotel_id int 当前门店id
   * 
   * 阿里云文档地址：https://apigateway.console.aliyun.com/?spm=5176.2020520001.106.d20apigateway.69864bd3ykDXY8#/cn-shenzhen/apis/detail/3c6c6c263ad545efb17123954221481c/d8e59c1f60d0423e8bbc4b113cadd769/definition/
   * 本地文档地址：http://14.18.91.179:9997/apipie/1.0/clean_orders/room_list
   * 
   * 返回值：
   * stat：房间实时状态, 1:干净房，2:脏房，3:已入住，4:停用，5:维修
   * clean_order_type：清洁类型, 1:正常单，2:指派单，3:人工结单，4:取消单，5:自动派单
   * clean_order_status：清洁单状态, 0:未接单，1:已接单，2:到达房间，3:开门成功，4:清洁盘点完成，5:离房成功，6:已核查
   */
  getDirtyRooms(params) {
    return this.instance.get('/api/v1/clean_orders/room_list', {
      params
    })
  },

  /**
   * 获取清洁单列表
   * @param {+} chainId 门店id
   * @param {*} startDate 创建时间开始
   * @param {*} endDate 创建时间结束
   * @param {*} serviceDateStart 清洁时间开始
   * @param {*} serviceDateEnd 清洁时间结束
   * @param {*} xbedOrderNo 订单号
   * @param {*} orderNo 清洁单号
   * @param {*} roomName 房号
   * @param {*} cleanTypeId 清洁单类型
   * @param {*} orderStatus 清洁单进度  0未接单，1已接单，2到达房间，3开门成功，4清洁盘点完成，5离房成功，6已核查
   * @param {*} orderType 清洁单状态  1正常单，2指派单，3人工结单，4取消单，5自动派单
   * @param {*} page 页码,必填
   * @param {*} rows 每页行数，必填
   * 
   */
  getCleanOrders(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/query', joinParams(_param))
  },

  /**
   * 获取门店管家列表
   * @param {+} chainId string，门店id，必填
   */
  getCleaners(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanertAction/chainCleanerList', joinParams(_param))
  },

  /**
   * 催单
   * @param {+} cleanOrderId 清洁单id
   */
  callHurry(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/xms/pushMessage', joinParams(_param))
  },

  /**
   * 取消清洁单
   * @param {+} cancelReason 取消原因，必填
   * @param {+} id 清洁单id，必填
   * @param {*} updateName string 发起取消请求的用户姓名, 选填
   * @param {*} updateRoomStatusSwitch 1 是取消了清洁单后，把房间致净
   */
  cancelCleanOrder(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/cancelCleanOrder', joinParams(_param))
  },

  /**
   * 指派单 - 指派一张清洁单给一个管家
   * @param {+} id string, 清洁单id，必填
   * @param {+} cleanerAccount string, 指派用户账号，必填
   * @param {+} updateName string，发起取消请求的用户姓名, 选填
   */
  assignCleanOrder(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/assignOrder', joinParams(_param))
  },

  /**
   * 新建清洁单
   * @param {+} cleanSource int, 清洁单客户端来源（9是XMS）
   * @param {+} createName string, 创建人姓名，必填
   * @param {*} plan string, 服务计划（简单原因） 1:在住清洁申请;2:退房;3:停用房清洁;4:开荒清洁;6:空房清洁;9特殊人工单, 必填（在清洁卡新建的时候传6）
   * @param {*} roomId int, xbed的房间id,必填
   * @param {*} serviceDate string, 服务日期 yyyy-MM-dd HH:mm:ss,必填
   * @param {*} xbedCheckinId int, xbed订单的入住单id, plan为1,2时必填
   * @param {*} xbedOrderNo string, 清洁单关联订单在xbed的订单号, plan为1,2时必填
   * @param {*} orderRemark string 备注
   * @param {*} itemDetail string 选择物品（1更换床品、2更换毛巾、3补充易耗品）如：1,2
   */
  createCleanOrder(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/add', joinParams(_param))
  },

  /**
   * 清洁完成
   * @param {+} id 清洁单id，必填
   * @param {+} finishReason string,结束原因
   * @param {+} updateName string，发起结束请求的用户姓名
   */
  finishCleanOrder(params) {
    // 接口需要加密
    let _param = cleanParams(params)
    return this.instance.post('admin/xbCleanOrderAction/overCleanOrder', joinParams(_param))
  },

  /**
   * 查询门店绑定的清洁员列表
   * @param {*} chainId 门店id 
   * @param {*} page 页数
   * @param {*} rows 每页条数 
   * @param {*} phone 手机号码 
   * @param {*} cleanerName 清洁员姓名 
   */
  getCleanerList(params) {
    let _param = cleanParams(params)
    return this.instance.post('/admin/xbCleanertAction/bindCleanerList', joinParams(_param))
  },

  /**
   * 绑定清洁员到门店
   * @param {*} chainId 清洁员id 
   * @param {*} chainName 门店名称  
   * @param {*} phone 管家手机号 
   * @param {*} operatorName 操作人 
   */
  bindCleaner(params) {
    let _param = cleanParams(params)
    return this.instance.post('/admin/xbCleanertAction/xmsBindChain', joinParams(_param))
  },

  /**
   * 解绑清洁员
   * @param {*} id 绑定id 
   * @param {*} operatorName 操作人
   */
  unbindCleaner(params) {
    let _param = cleanParams(params)
    return this.instance.post('/admin/xbCleanertAction/unbindChain', joinParams(_param))
  }



  // /**
  //  * 一键呼叫清洁 （批量新建、催单）
  //  * @param {+} hotel_id 门店id
  //  */
  // callOneClickClean(params) {
  //   return this.instance.post('api/v1/clean_orders/one_click_clean', {
  //     ...params
  //   })
  // },

  // /**
  //  * 清洁单详情
  //  * @param {+} id
  //  */
  // getCleanOrderDetail(params) {
  //   return this.instance.get('api/v1/clean_orders/id', {
  //     params: handleParams(params)
  //   })
  // },

  // /**
  //  * 导出清洁单列表 (直接返回文件,采用window.open调用，这里没有用到，clean-list文件中单独实现)
  //  * @param {+} hotel_id 门店id
  //  * @param {*} created_at_start 创建时间开始
  //  * @param {*} created_at_end 创建时间结束
  //  * @param {*} started_at_start 清洁时间开始
  //  * @param {*} started_at_end 清洁时间结束
  //  * @param {*} order_no 订单号
  //  * @param {*} clean_order_no 清洁单号
  //  * @param {*} room_no 房号
  //  * @param {*} room_type 房型
  //  * @param {*} order_type 清洁单类型
  //  * @param {*} clean_status_code 清洁单状态  0：待清洁 1:清洁中 2:清洁完成
  //  * @param {*} accept_status_code 清洁单接单状态  0:未接单 1:已接单 2:已取消
  //  * @param {*} clean_name 清洁人员姓名
  //  * 
  //  */
  // exportCleanOrders(params) {
    
  //   return this.instance.get('api/v1/clean_orders/export', {
  //     params: handleParams(params)
  //   })
  // },
}


// WEBPACK FOOTER //
// ./src/api/clean.js